import { render, staticRenderFns } from "./PedestalSalesForm.vue?vue&type=template&id=40b59aae&"
import script from "./PedestalSalesForm.vue?vue&type=script&lang=js&"
export * from "./PedestalSalesForm.vue?vue&type=script&lang=js&"
import style0 from "./PedestalSalesForm.vue?vue&type=style&index=0&id=40b59aae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports